import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { trackAddToCart } from '../utils/metaPixel';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: 'easeOut'
    }
  }
};
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center pt-20 pb-16 overflow-hidden" data-id="element-32">
      {/* Decorative top line */}
      <div className="absolute top-0 left-0 w-full h-1 bg-patriotRed" aria-hidden="true" data-id="element-33" />

      <div className="max-w-6xl mx-auto px-6 md:px-8 w-full" data-id="element-34">
        <div className="flex flex-col md:flex-row items-center justify-between gap-12 md:gap-8" data-id="element-35">
          {/* Text Content */}
          <motion.div className="flex-1 text-center md:text-left z-10" variants={containerVariants} initial="hidden" animate="visible" data-id="element-36">
            <motion.p variants={itemVariants} className="text-patriotRed uppercase tracking-[0.2em] text-sm font-semibold mb-6" data-id="element-37">
              An Editorial Manifesto
            </motion.p>

            <motion.h1 variants={itemVariants} className="text-5xl md:text-7xl font-black text-offwhite leading-[1.1] mb-6" data-id="element-38">
              A Vision for Freedom in an Age of Silence.
            </motion.h1>

            <motion.p variants={itemVariants} className="text-base md:text-lg font-light text-offwhite-secondary leading-relaxed mb-10 max-w-2xl mx-auto md:mx-0" data-id="element-39">
              A powerful chronicle of the cultural fracture, the digital
              battlefield, and the courageous voice that stood for the Republic.
            </motion.p>

            <motion.div variants={itemVariants} className="flex flex-col items-center md:items-start gap-4" data-id="element-40">
              <a href="https://templeofpages.com/cart/48643597205747:1" onClick={() => trackAddToCart()} className="inline-block bg-patriotRed hover:bg-patriotRed-hover text-offwhite px-8 py-4 uppercase tracking-wider font-semibold text-sm transition-colors duration-300 w-full md:w-auto shadow-lg shadow-patriotRed/20 text-center no-underline" aria-label="Download the Digital Edition — $13.99" data-id="element-41">
                Download the Digital Edition — $13.99
              </a>
            </motion.div>
          </motion.div>

          {/* Image Content */}
          <motion.div className="flex-1 flex justify-center md:justify-end w-full max-w-md md:max-w-none" initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 1,
          delay: 0.5,
          ease: 'easeOut'
        }} data-id="element-42">
            <div className="relative" data-id="element-43">
              <div className="absolute inset-0 bg-patriotRed/10 blur-3xl rounded-full transform scale-90" aria-hidden="true" data-id="element-44" />
              <img src="https://cdn.magicpatterns.com/uploads/pXxcLZXbwN4rNSkNfZAUPv/imagen_publicidad_y_landing.png" alt="The Voice They Couldn't Silence - Book Cover on iPad" className="relative z-10 w-full h-auto drop-shadow-2xl object-contain max-h-[70vh]" loading="eager" data-id="element-45" />
              <div className="absolute -top-3 -right-3 z-20 w-24 h-24 rounded-full bg-patriotRed flex items-center justify-center shadow-lg shadow-patriotRed/30 border-2 border-offwhite/20" data-id="element-46">
                <span className="text-offwhite text-xs font-bold uppercase tracking-wider leading-tight text-center" data-id="element-47">
                  Digital
                  <br data-id="element-48" />
                  Edition
                </span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}